import styled, { css } from "styled-components";

const ViewSelectorButton = styled.button`
  display: flex;
  padding: 4px 6px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 3px;
  background-color: transparent;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  border: 1px solid var(--primary-dark-200);
  color: var(--primary-blue);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
`;

export const SingleViewBtn = styled(ViewSelectorButton)`
  transition: padding 0.2s;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: var(--primary-dark-50);
      color: var(--primary-dark);
      font-weight: 600;
      border: 1px solid var(--primary-dark-200);
    `}
`;

export const AllViewBtn = styled(ViewSelectorButton)`
  white-space: nowrap;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: var(--primary-dark-100);
      color: var(--primary-dark);
      font-weight: 600;
      border: 1px solid transparent;
    `}
`;
